module.exports = window["styled"];